module.exports = __webpack_public_path__ + "img/tpc-38.6376a8ad.webp";